<template>
  <div>
    <!-- <v-breadcrumbs :items="bread"></v-breadcrumbs> -->
    <v-row class="my-2" style="margin: 0">
      <v-col class="show" cols="12" md="3" sm="12" style="padding-left: 0px">
        <!-- <v-card height="100%" width="500" class="m-auto"> -->
        <v-card color="transparent" height="100%" width="500">
          <v-list>
            <v-list-group
              v-for="item in items"
              :key="item.id"
              v-model="item.active"
              :prepend-icon="item.action"
              no-action
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title v-text="item.title"></v-list-item-title>
                </v-list-item-content>
              </template>

              <!-- v-for="child in item.items" -->
              <v-list-item
                v-for="child in category.data"
                :key="child.id"
                link
                v-if="item.id == 1"
              >
                <v-list-item-content style="font-weight: 900">
                  <v-row style="margin: 0px">
                    <v-list-item-icon>
                      <picture>
                        <source type="image/webp" :srcset="child.image" />
                        <v-img
                          class=""
                          :src="child.image"
                          max-height="24"
                          max-width="24"
                        ></v-img>
                      </picture>
                    </v-list-item-icon>
                    <p class="" style="margin-top: 22px">
                      {{ child.name }}
                    </p>
                    <v-list-group
                      class="mr-auto"
                      v-if="child.subgroups.length != 0"
                      :value="true"
                      no-action
                      sub-group
                    >
                      <!-- <template v-slot:activator>
                          <v-list-item-content>
                            <v-list-item-title></v-list-item-title>
                          </v-list-item-content>
                        </template> -->
                      <v-list-item
                        v-for="(subgroups, i) in child.subgroups"
                        :key="i"
                        link
                        @click="click(subgroups.id)"
                      >
                        <v-list-item-icon>
                          <picture>
                            <source
                              type="image/webp"
                              :srcset="subgroups.image"
                            />
                            <v-img
                              class="ml-1 mb-1"
                              :src="subgroups.image"
                              max-height="24"
                              max-width="24"
                            ></v-img>
                          </picture>
                        </v-list-item-icon>
                        <v-list-item-title
                          v-text="subgroups.name"
                        ></v-list-item-title>
                      </v-list-item>
                    </v-list-group>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-for="childs in item.items"
                :key="childs.id"
                link
                @click="clicksort(childs.title)"
              >
                <v-list-item-content
                  style="font-weight: 800"
                  v-if="item.id == 2"
                >
                  <v-row style="margin: 0px">
                    <p class="mt-1 mr-6">
                      {{ childs.title }}
                    </p>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list>
          <v-divider class="my-2"></v-divider>
          <!-- <h5 class="mb-2" align="center">نصب اپلیکیشن نامیا</h5> -->
          <v-row class="mx-1" align="center">
            <v-col class="px-1" cols="12" md="4" align="center">
              <picture>
                <source
                  type="image/webp"
                  srcset="@/assets/images/download_app/bazar.png"
                />
                <a
                  target="_blank"
                  href="https://cafebazaar.ir/"
                  rel="noopener noreferrer"
                >
                  <v-img
                    class="cursor images inner-img"
                    src="@/assets/images/download_app/bazar.png"
                  ></v-img>
                </a>
              </picture>
            </v-col>
            <v-col class="px-1" cols="12" md="4" align="center">
              <picture>
                <source
                  type="image/webp"
                  srcset="@/assets/images/download_app/google.png"
                />
                <a
                  target="_blank"
                  href="https://play.google.com/"
                  rel="noopener noreferrer"
                >
                  <v-img
                    class="cursor images inner-img"
                    src="@/assets/images/download_app/google.png"
                  ></v-img>
                </a>
              </picture>
            </v-col>
            <v-col class="px-1" cols="12" md="4" align="center">
              <picture>
                <source
                  type="image/webp"
                  srcset="@/assets/images/download_app/myket.png"
                />
                <a
                  target="_blank"
                  href="https://myket.ir/app/ir.vira.namya"
                  rel="noopener noreferrer"
                >
                  <v-img
                    class="cursor images inner-img"
                    src="@/assets/images/download_app/myket.png"
                  ></v-img>
                </a>
              </picture>
            </v-col>
            <v-col class="px-1" cols="12" md="4" align="center">
              <picture>
                <source
                  type="image/webp"
                  srcset="@/assets/images/download_app/feuture.png"
                />
                <a width="95" text target="_blank" rel="noopener noreferrer">
                  <v-img
                    class="cursor images inner-img"
                    src="@/assets/images/download_app/feuture.png"
                  ></v-img>
                </a>
              </picture>
            </v-col>
            <v-col class="px-1" cols="12" md="4" align="center">
              <picture>
                <source
                  type="image/webp"
                  srcset="@/assets/images/download_app/application.png"
                />
                <a
                  target="_blank"
                  href="https://namya.ir/namya.apk"
                  rel="noopener noreferrer"
                >
                  <v-img
                    id="app"
                    class="cursor images inner-img"
                    src="@/assets/images/download_app/application.png"
                  ></v-img>
                </a>
              </picture>
            </v-col>
            <v-col class="px-1" cols="12" md="4" align="center">
              <picture>
                <source
                  type="image/webp"
                  srcset="@/assets/images/download_app/webapp.png"
                />
                <a
                  target="_blank"
                  href="https://namya.ir/m"
                  rel="noopener noreferrer"
                >
                  <v-img
                    class="cursor images inner-img"
                    src="@/assets/images/download_app/webapp.png"
                  ></v-img>
                </a>
              </picture>
            </v-col>
          </v-row>
          <v-divider class="my-2"></v-divider>
          <v-row class="p-2" align="center">
            <v-col cols="4" align="center">
              <v-btn
                width="95"
                text
                target="_blank"
                rel="noopener noreferrer"
                href="https://trustseal.enamad.ir/?id=228127&Code=SX9GI7jjWs9e6V42foSg"
              >
                <picture>
                  <source
                    type="image/webp"
                    srcset="@/assets/images/checked/enamad.png"
                  />
                  <v-img
                    :aspect-ratio="16 / 9"
                    class="m-1 cursor images"
                    height="100"
                    width="75"
                    src="@/assets/images/checked/enamad.png"
                  ></v-img>
                </picture>
              </v-btn>
            </v-col>
            <v-col cols="4" align="center">
              <picture>
                <source
                  type="image/webp"
                  srcset="@/assets/images/checked/kasbokar.png"
                />
                <v-img
                  :aspect-ratio="16 / 9"
                  class="m-1 cursor images"
                  height="100"
                  width="75"
                  src="@/assets/images/checked/kasbokar.png"
                ></v-img>
              </picture>
            </v-col>
            <v-col cols="4" align="center">
              <picture>
                <source
                  type="image/webp"
                  srcset="@/assets/images/checked/rezi.png"
                />
                <v-img
                  :aspect-ratio="16 / 9"
                  class="m-1 cursor images"
                  height="100"
                  width="75"
                  src="@/assets/images/checked/rezi.png"
                ></v-img>
              </picture>
            </v-col>
          </v-row>
          <v-divider class="my-2"></v-divider>
          <v-list
            class="d-flex mx-auto"
            dense
            nav
            style="justify-content: center"
            link
          >
            <div v-for="item in items_footer" :key="item.title">
              <v-list-item-content>
                <v-btn text>
                  <h4>{{ item.title }}</h4>
                </v-btn>
              </v-list-item-content>
            </div>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" md="9" sm="12" style="height: 100%">
        <!-- <Slider /> -->
        <Booths :category="categoryclick" :sort="sortclick" />
        <!-- <Dialog :visible="dialog" @close="dialog = false" />
        <Dialog :visible2="dialog2" @close="dialog2 = false" /> -->
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Slider from "@/components/sliders/slider.vue";
import Booths from "@/components/booths/booths.vue";
import Dialog from "@/components/dialog/dialog.vue";

export default {
  components: {
    Booths,
    Dialog,
    Slider,
  },
  data() {
    return {
      // dialog: false,
      // dialog2: false,
      right: null,
      category: [],
      catidclick: "",
      categoryclick: null,
      sortclick: "",
      red: false,
      items: [
        {
          id: 1,
          title: "دسته بندی",
          action: "mdi-view-dashboard",
        },
        {
          id: 2,
          title: "مرتب سازی",
          action: "mdi-filter-menu",
          items: [
            {
              id: 1,
              title: "مرتبط ترین",
              //defualt
            },
            {
              id: 2,
              title: "بالاترین رتبه",
              //rank
            },
            {
              id: 3,
              title: "جدیدترین",
              image: "mdi-new-box",
              //newest
            },
            {
              id: 4,
              title: "بیشترین بازدید",
              //view
            },
            {
              id: 5,
              title: "بالاترین امتیاز",
              //Rank
            },
            {
              id: 6,
              title: "نزدیک ترین",
              //near
            },
          ],
        },
      ],
      items_footer: [
        {
          id: 1,
          title: "درباره ما",
          icon: "mdi-view-dashboard",
          des: "نامیا شبکه گسترده آنلاین کسب و کار ها در طیف های مختلف است که عملکرد آن مشابه نمایشگاه است. هر شخصی می تواند به راحتی در نامیا کسب و کاری با نام و برند خود ثبت و محصولات و خدمات  خود را عرضه نماید. نامیا فروشنده و ارائه دهنده هیچگونه کالایی نیست و تنها واسطه ای میان اشخاص و کسب و کارها می باشد نامیا با هدف دسترسی سریع و آسان کاربران به خدمات و اصناف اطراف خود طراحی شده است کلمه نامیا به معنی مشهور می باشد. کاربران نامیا می توانند کسب و کارهای مورد نیازشان را بر اساس نوع صنف و محل استقرار و نام جستجو و آنها را ارزیابی کنند شما با نامیا صفحه اختصاصی برای کسب و کار خود ایجاد می کنید که می توان فروش اینترنتی محصولات،کارت ویزیت دیجیتال ، تور مجازی فروشگاه ،نقشه محل فعالیت- توضیحات زمینه فعالیت واطلاعات تماس ، خدمات وسرویس ها ،ایجاد بلاگ ، نظرات ، تخفیفات حضوری و آنلاین  پیش بینی شده است.",
        },
        { id: 2, title: "ثبت شکایت", icon: "mdi-forum" },
        {
          id: 3,
          title: "قوانین",
          icon: "mdi-forum",
          des: "قوانین ایجاد کسب و کار ساخت کسب و کار مجازی در نامیا و فروش محصول در نامیا کاملا رایگان بوده و نامیا هیچ مبلغی از فروشنده بابت استفاده از این خدمات دریافت نمی نماید هدف ما ایجاد یک محیط سالم و امن در نامیا  است. به همین دلیل قوانین نامیا به عنوان یک مرجع برای همه کاربران نامیا از جمله خریدارن و فروشندگان به منظور سالم نگه داشتن این محیط برای خرید و فروش تدوین شده و لازم الاجراست. ما متعهد به حفظ محیطی امن با تلاش تک تک شما هستیم هر فردی درمقام مصرف کننده دارای حقوقی است که این حقوق می بایست از جانب تولید کنندگان و توزیع کنندگان محصولات محترم شمرده شود این قانون مجموعه اصول و قواعدی است که برای مبادله آسان و ایمن اطلاعات در واسط های الکترونیکی و با استفاده از سیستم های ارتباطی جدید به کار می رود در صورتیکه کسب و کاری  مبلغ را شارژ نمائید جهت استفاده از خدمات نامیا (کارت ویزیت دیجیتال ،ارسال انبوه پیام و.... )  قابل برداشت نمی باشد فقط در صورتیکه فروش اینترنتی  محصول داشته باشد از طریق درگاه اینترنتی نامیا    ",
        },
        { id: 4, title: "تماس با ما", icon: "mdi-forum" },
      ],
      bread: [
        {
          text: "نامیا",
          disabled: false,
          href: "home",
        },
        {
          text: "غرفه ها",
          disabled: false,
          href: "/",
        },
      ],
    };
  },
  methods: {
    async getcategory() {
      var self = this;
      let response = await self.axios.get(
        "https://namya.ir/api/v1/businesses/group/boothGroups"
      );
      // console.log(self.$route.params.name);
      self.category = response.data;
    },
    async click(id) {
      if (id) {
        this.categoryclick = id;
        this.$nextTick(() => this.$root.$refs.A.listboothscategory());
      }
    },
    async clicksort(sort) {
      if (sort) {
        if (sort == "مرتبط ترین") {
          this.sortclick = "defualt";
          this.$nextTick(() => this.$root.$refs.A.listboothssort());
        } else if (sort == "بالاترین رتبه") {
          this.sortclick = "rank";
          this.$nextTick(() => this.$root.$refs.A.listboothssort());
        } else if (sort == "جدیدترین") {
          this.sortclick = "newest";
          this.$nextTick(() => this.$root.$refs.A.listboothssort());
        } else if (sort == "بیشترین بازدید") {
          this.sortclick = "view";
          this.$nextTick(() => this.$root.$refs.A.listboothssort());
        } else if (sort == "بالاترین امتیاز") {
          this.sortclick = "rank";
          this.$nextTick(() => this.$root.$refs.A.listboothssort());
        } else if (sort == "نزدیک ترین") {
          this.sortclick = "near";
          this.$nextTick(() => this.$root.$refs.A.listboothssort());
        }
      }
    },
  },
  created() {
    this.getcategory();
  },
};
</script>

<style lang="css" scoped>
.top {
  top: -540px;
}
.width {
  max-width: 940px;
}
.v-card__title {
  font-size: 1rem;
  font-weight: 500;
}
.cursor {
  cursor: pointer;
}
.images {
  /* width: 140px; */
  border-radius: 12px;
}
.padding {
  padding: 6px !important;
}
.top-avatar {
  margin-top: -50px;
}
.v-list__title {
  font-weight: 200;
}
.v-list__subtitle {
  font-weight: 200;
}
.v-list-item__title,
.v-list-item__subtitle {
  line-height: 1.2;
  font-weight: 200;
}
.v-application--is-rtl
  .v-list-group--no-action
  > .v-list-group__items
  > .v-list-item {
  padding-right: 10px;
}
.v-application--is-rtl .v-list-group--sub-group .v-list-group__header {
  padding-right: 0px;
}
.v-list-group--sub-group {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
}
.v-list-item__content {
  align-items: center;
  align-self: center;
  display: flex;
  flex-wrap: wrap;
  flex: 1 1;
  overflow: hidden;
  padding: 0px;
}
@media (max-width: 900px) {
  .show {
    display: none;
  }
  .j-center {
    justify-content: center;
  }
}
.inner-img {
  transition: 0.3s;
}

.inner-img:hover {
  transform: scale(1.1);
}
h4 {
  font-weight: 800;
  letter-spacing: 0px;
  cursor: pointer;
}
* >>> .v-responsive__content {
  width: 95px !important;
}
.v-application--is-rtl .v-list-item__action:last-of-type:not(:only-child),
.v-application--is-rtl .v-list-item__avatar:last-of-type:not(:only-child),
.v-application--is-rtl .v-list-item__icon:last-of-type:not(:only-child) {
  margin-right: 0px;
}
</style>
